
import MarketDataHeader from '@/components/features/market-data/components/MarketDataHeader';
import MarketDataFilters from '@/components/features/market-data/components/filters/MarketDataFilters';
import Gutter from '@/ui-kit/components/gutter';
import { FormEventType } from '@/ui-kit/components/form/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import { StylePositionType, StyleSizeType } from '@/ui-kit/styles/enums';
import HandleMarketDataForm from '@/components/features/market-data/mixins/HandleMarketDataForm';
import { FormProperty } from '@/components/features/sold-data/shared/components/enums';
import CheckFilterValues from '@/components/page-specific/sold-data/mixins/CheckFilterValues';
import {
  MarketDataFilterFormControlName,
} from '@/components/features/market-data/components/filters/MarketDataFiltersFormControls';
import MarketDataSummaryTable from '@/components/features/market-data/components/summary-table/MarketDataSummaryTable';
import MarketDataChart from '@/components/features/market-data/components/chart/MarketDataChart';

export default {
  name: 'MarketDataContent',
  components: {
    MarketDataHeader,
    MarketDataFilters,
    Gutter,
    MarketDataSummaryTable,
    MarketDataChart,
  },
  mixins: [HandleMarketDataForm, CheckFilterValues],
  data() {
    return {
      GutterProperty,
      StyleSizeType,
      StylePositionType,
      FormProperty,
      FormEventType,
      chartParams: null,
    };
  },
  computed: {
    province() {
      return this.filtersForm.getControl(MarketDataFilterFormControlName.Province)?.value;
    },
  },
  async mounted() {
    this.initFilterForm();

    if (this.checkFiltersValues(this.$route.query)) {
      await this.loadResultsByFilters(this.filtersForm.value);
      this.handleChartParams();
    }
  },
  methods: {
    handleChartParams() {
      this.chartParams = { ...this.filtersForm.value };
    },
    handleFormSubmit(value) {
      this.handleChartParams();
      this.handleFiltersSubmit(value);
    },
  },
};
